<template>
    <!-- <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="formDatePicker"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :disabled="!can('api.v1.patients.update') && can('api.v1.patients.show')"
    >
        <template #activator="{ on, attrs }">
            <v-text-field
                v-model="formDatePicker"
                :label="label"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="formDatePicker" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="formDatePicker = false"> Cancel </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(formDatePicker)"> OK </v-btn>
        </v-date-picker>
    </v-menu> -->
    <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template #activator="{}">
            <v-text-field
                v-model="formatedDateValue"
                :label="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"
                :placeholder="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"
                readonly
                dense
                rounded
                outlined
                :clearable="formatedDateValue !== null"
                :class="setClass"
                :error-messages="errorMessage"
                :disabled="isReadonly || $attrs.disabled"
                background-color="#fff"
                v-bind="$attrs"
                @click="menu2 = !menu2"
                v-on="$listeners"
                @click:clear="clear"
            ></v-text-field>
        </template>
        <v-date-picker v-model="formDatePicker" @change="change"></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'BDatePickerStore',
    props: {
        setClass: {
            type: String,
            required: false,
            default: '',
        },
        toMutate: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        menu2: false,
        store: null,
        propertyToMutate: null,
        formatedDateValue: null,
        dates: {
            weekdays: [1, 7],
        },
    }),
    computed: {
        formDatePicker: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
                this.$emit('change', value);
            },
        },
        errorMessage: {
            get() {
                return _.get(this.$store.state[this.store].errorMessages, this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/resetPropertyError`, { value, property: this.propertyToMutate });
            },
        },
        isReadonly() {
            if (typeof this.$attrs.readonly !== 'undefined') {
                return this.$attrs.readonly;
            }

            if (this.filters) {
                return false;
            }

            if (this.forceReadonly) {
                return true;
            }

            const propertyToMutate = this.propertyToMutate.toString().split('.').slice(-2).join('.');

            if (!is_writeable(propertyToMutate)) {
                return true;
            }

            return false;
        },
    },
    watch: {
        formDatePicker(newValue) {
            if (!newValue) {
                this.formatedDateValue = null;
            }
            if (newValue) {
                this.formatedDateValue = moment(newValue).format(this.$root.dateFormat);
            }
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
        this.formatedDateValue = this.formDatePicker ? moment(this.formDatePicker).format(this.$root.dateFormat) : null;
    },
    methods: {
        clear() {
            this.formDatePicker = null;
        },
        change() {
            this.errorMessage = [];
            this.menu2 = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
